/* eslint-disable no-alert */

import { logError } from '../../services/loggerService';
import { isLoggedIn, getPageName } from './Helpers';
import { MY_FEED, PROSPECT_3_0_DISCOVER } from './mvaViews';

export const mvaBridgeApiCall = (bridgeAPIMsg) => {
  try {
    const bridgeAPIPostJson = JSON.stringify(bridgeAPIMsg);
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.mfAppInterface &&
      window.webkit.messageHandlers.mfAppInterface.postMessage
    ) {
      window.webkit.messageHandlers.mfAppInterface.postMessage(bridgeAPIPostJson);
    }
    if (window.mfAppInterface && window.mfAppInterface.postMessage) {
      window.mfAppInterface.postMessage(bridgeAPIPostJson);
    }
  } catch (err) {
    console.log(err);
  }
};

export const mvaLinkApiCall = (linkUrl) => {
  const bridgeAPIMsg = {
    actionType: 'openURL',
    pageType: 'openBrowser',
    browserUrl: linkUrl,
    openInWebview: true,
  };
  mvaBridgeApiCall(bridgeAPIMsg);
};

const emptyFunc = () => null;

export const triggerIsApplePaySupported = (callback) => {
  window.isApplePaySupportedCallback = callback || emptyFunc;
  const bridgeAPIMsg = {
    actionType: 'isApplePaySupported',
    jsCallback: 'window.isApplePaySupportedCallback',
  };
  // {"isSuccess":"Y","isApplePaySupported":"Y/N"}
  mvaBridgeApiCall(bridgeAPIMsg);
};

export const triggerApplePay = (merchantId, lineItems, callback) => {
  window.applePayCallback = callback;
  const bridgeAPIMsg = {
    actionType: 'applePayPayment',
    jsCallback: 'window.applePayCallback',
    lineItems,
    merchantId,
  };
  mvaBridgeApiCall(bridgeAPIMsg);
};

export const isMVA = () => window.navigator.userAgent.indexOf('MY_VZW_APP') > -1;

export const resetNavigationTitle = (isMVAChannelFlag) => {
  if (isMVAChannelFlag) {
    // write below code only when it is APP.
    const bridgeAPIMsg = {
      actionType: 'updateNavigation',
      navigationBar: {
        moleculeName: 'navigationBar',
        title: 'Home Internet', // add title what is displayed in NSA (for BAU it is Home Internet)
        alwaysShowBackButton: false, // false if u  want to hide the back
      },
    };
    mvaBridgeApiCall(bridgeAPIMsg); // calling this will update the navigation title
  }
};

export const setNavigationTitle = (isMVAChannelFlag, title) => {
  if (isMVAChannelFlag) {
    // write below code only when it is APP.
    const bridgeAPIMsg = {
      actionType: 'updateNavigation',
      navigationBar: {
        moleculeName: 'navigationBar',
        title,
        alwaysShowBackButton: false, // false if u  want to hide the back
      },
    };
    console.log(bridgeAPIMsg, 'kk');
    mvaBridgeApiCall(bridgeAPIMsg); // calling this will update the navigation title
  }
};

export const renderNavBarCloseICON = (targetView) => {
  try {
    const payLoad = {
      actionType: 'updateNavigation',
      navigationBar: {
        moleculeName: 'navigationBar',
        alwaysShowBackButton: true,
        backButton: {
          moleculeName: 'navigationImageButton',
          image: 'nav_close',
          action: {
            title: 'Close',
            actionType: 'openPage',
            pageType: targetView,
            analyticsData: {
              'vzdl.page.linkName': 'cross action',
              'vzdl.page.sourceChannel': 'MVA',
              'vzdl.page.displayChannel': 'MVA',
              'vzdl.page.id': '5G_confirmation',
              'vzdl.page.name': '5G_confirmation',
              'vzdl.page.pageTypeLinkname': '5G confirmation|cross action',
              'vzdl.page.webViewPage': getPageName(),
            },
          },
        },
      },
    };
    mvaBridgeApiCall(payLoad);
  } catch (mvaBridgeError) {
    logError('renderNavBarCloseICON-bridgeAPI', mvaBridgeError);
  }
};

export const renderConfirmationCloseICON = () => renderNavBarCloseICON(isLoggedIn() ? MY_FEED : PROSPECT_3_0_DISCOVER);
